import React from "react";
import { Tabs } from "antd";
import { cn } from "../../utils/cn";

const CommonTabs = ({
    items,
    defaultActiveKey,
    activeKey,
    onChange,
    className,
    tabBarStyle,
    type = "line",
    ...props
}) => {
    return (
        <Tabs
            defaultActiveKey={defaultActiveKey}
            activeKey={activeKey}
            onChange={onChange}
            items={items}
            className={cn(
                "common-tabs",
                "[&_.ant-tabs-tab-active_.ant-tabs-tab-btn]:!text-primary",
                "[&_.ant-tabs-ink-bar]:!bg-primary",
                "[&_.ant-tabs-tab:hover_.ant-tabs-tab-btn]:!text-primary"
                , className)}
            tabBarStyle={tabBarStyle}
            type={type}
            {...props}
        />
    );
};

export default CommonTabs;
